const allowedDomains = ['.wixprod.net', 'localhost', '.wix.com', '.wixpress.com'];

export function isWixDomain(domain: string) {
  const isAllowed = allowedDomains.some((allowed) => domain.endsWith(allowed));
  const isIp = /^\d+$/.test(domain.replace(/[[\]:.]/g, ''));

  return isAllowed || isIp;
}
